var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statuses"},[_c('span',{staticClass:"status"},[_vm._v("Invited")]),_c('span',{staticClass:"resend action last",attrs:{"title":"Resend Invite"},on:{"click":function($event){$event.stopPropagation();return _vm.resend.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }